import { APIModel } from "./api-model";

/**
 * Class to encapsulate a user for any _by User
 */
export class AssociatedUser extends APIModel {
  full_name!: string;

  static fieldsToMap = {
    direct: [
      'full_name'
    ]
  }

  static buildFromAPI(record: any): AssociatedUser {
    const row = new AssociatedUser();
    record = record || {};

    this.mapFieldsDirectly<AssociatedUser>(AssociatedUser.fieldsToMap.direct, record, row);

    return row
  }
}